/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SetVariantMainImageMutationResponse,
  SetVariantMainImagePathParams,
  SetVariantMainImage400,
  SetVariantMainImage404,
} from '../types/SetVariantMainImage'

function getSetVariantMainImageUrl({
  document_id,
  variant_id,
}: {
  document_id: SetVariantMainImagePathParams['document_id']
  variant_id: SetVariantMainImagePathParams['variant_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/products/catalog/variants/${variant_id}/main-image/${document_id}/` as const,
  }
  return res
}

/**
 * @description Set a specific image as the main image for a variant.
 * Args:
 * variant_id: ID of the variant
 * document_id: ID of the document to set as main image
 * Returns:
 * Response with success message or error
 * @summary Set main image for a variant
 * {@link /api/v1/products/catalog/variants/:variant_id/main-image/:document_id/}
 */
export async function setVariantMainImage(
  {
    document_id,
    variant_id,
  }: {
    document_id: SetVariantMainImagePathParams['document_id']
    variant_id: SetVariantMainImagePathParams['variant_id']
  },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SetVariantMainImageMutationResponse,
    ResponseErrorConfig<SetVariantMainImage400 | SetVariantMainImage404>,
    unknown
  >({
    method: 'POST',
    url: getSetVariantMainImageUrl({ document_id, variant_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
